import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ScryfallCard } from '@/types/scryfall';
import { Plus, Minus } from 'lucide-react';
import { useState } from 'react';

interface CardActionsProps {
  card: ScryfallCard;
  addCard: (card: ScryfallCard) => void;
  removeCard: (card: ScryfallCard) => void;
  setCardCount: (card: ScryfallCard, count: number) => void;
  count: number;
}

export const CardActions = ({ card, addCard, removeCard, setCardCount, count }: CardActionsProps) => {
  const [editingCount, setEditingCount] = useState<string>('');

  const handleCountChange = (value: string) => {
    setEditingCount(value);
  };

  const handleCountBlur = () => {
    if (editingCount === '' || isNaN(parseInt(editingCount, 10))) {
      setCardCount(card, 0);
    } else {
      setCardCount(card, parseInt(editingCount, 10));
    }
    setEditingCount('');
  };

  return (
    <div className="flex flex-col items-center gap-2 max-w-fit">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => addCard(card)}
        className="h-6 w-6 text-muted-foreground hover:text-primary hover:bg-primary/10"
      >
        <Plus className="h-4 w-4" />
      </Button>
      <Input
        type="number"
        value={editingCount || count}
        onChange={(e) => handleCountChange(e.target.value)}
        onBlur={handleCountBlur}
        className="w-12 h-7 text-center bg-transparent border-none focus-visible:ring-0"
      />
      <Button
        variant="ghost"
        size="icon"
        onClick={() => removeCard(card)}
        className="h-6 w-6 text-muted-foreground hover:text-destructive hover:bg-destructive/10"
      >
        <Minus className="h-4 w-4" />
      </Button>
    </div>
  );
};
